// Help text for: Tools > Complaint Ticket.
// Keys are referenced as "complaintTicket.<field>" by <FieldHelp id=... />. Entry shape:
//   title  - field name as shown on screen
//   use    - what the field is for / how to read it
//   source - measured | calculated | backend | default | setting | input
//   how    - where the value comes from: formula, default value, or who sets it
const help = {
  totalFiled: {
    title: "Total Filed",
    use: "How many complaint tickets you have raised.",
    source: "calculated",
    how: "Counts every ticket listed under My Tickets for your login, whatever state it is in.",
  },
  open: {
    title: "Open",
    use: "Tickets nobody has picked up yet.",
    source: "calculated",
    how: "Counts your tickets marked Open. Every new ticket starts out Open.",
  },
  inProgress: {
    title: "In Progress",
    use: "Tickets the support team is working on right now.",
    source: "calculated",
    how: "Counts your tickets marked In Progress. Only the support team can move a ticket into this state.",
  },
  resolved: {
    title: "Resolved",
    use: "Tickets that have been dealt with.",
    source: "calculated",
    how: "Counts your tickets marked Resolved or Closed — both land here.",
  },
  form: {
    title: "Register a Support Complaint",
    use: "Raises a complaint with the support team about missing data, a meter that is off, readings that look wrong, or a bill.",
    source: "input",
    how: "Subject and details must be filled in; the rest is up to you. Every ticket goes in at High priority and comes back with a reference like TKT-000123 and the state Open.",
  },
  subject: {
    title: "Subject / Summary",
    use: "A short headline for the problem, shown in your ticket list.",
    source: "input",
    how: "Must be filled in. Starts empty.",
  },
  category: {
    title: "Category",
    use: "The kind of problem, so it lands with the right person.",
    source: "input",
    how: "Starts on Missing Data. The other choices are Offline Meter, Inaccurate Readings, Billing Issue and Other. It drops back to Missing Data after each ticket is sent.",
  },
  machine: {
    title: "Affected Machine/Meter",
    use: "The machine or meter the problem is about, if it is about one.",
    source: "input",
    how: "You can leave this out. The list shows your machines with their meter IDs, narrowed to the branch picked at the top of the screen (all machines when that is set to All).",
  },
  email: {
    title: "Contact Email",
    use: "Where the support team can email you about this ticket.",
    source: "input",
    how: "You can leave this out — the email saved on your account is then used instead.",
  },
  phone: {
    title: "Contact Phone",
    use: "A number the support team can ring about this ticket.",
    source: "input",
    how: "You can leave this out — the phone number saved on your account is then used instead.",
  },
  description: {
    title: "Details / Description of Issue",
    use: "The full story of the problem, ideally with dates, times and readings.",
    source: "input",
    how: "Must be filled in. The category, meter ID and machine name you chose are added on to the end of this text when the ticket is sent.",
  },
  ticketId: {
    title: "Ticket ID",
    use: "The reference to quote whenever you contact support about this ticket.",
    source: "backend",
    how: "Handed out when the ticket is registered: TKT- followed by a six-digit running number.",
  },
  ticketSubject: {
    title: "Subject",
    use: "The ticket's headline, with the start of its details and your contact information underneath.",
    source: "input",
    how: "What you typed into Subject / Summary when you sent the ticket.",
  },
  status: {
    title: "Status",
    use: "Where the ticket stands with the support team.",
    source: "backend",
    how: "New tickets start Open. The support team moves it to In Progress, then Resolved or Closed, as they work through it.",
  },
  ticketCategory: {
    title: "Category",
    use: "The kind of problem chosen when the ticket was sent.",
    source: "input",
    how: "What you picked in the Category box. Shows Other if no category was saved with the ticket.",
  },
  dateSubmitted: {
    title: "Date Submitted",
    use: "When the ticket was registered.",
    source: "backend",
    how: "Stamped at the moment the ticket was saved, shown in your own local time.",
  },
  contactEmail: {
    title: "Contact Email",
    use: "The email the support team will use for this ticket.",
    source: "backend",
    how: "The email you typed in, or the one on your account if you left it blank.",
  },
  contactPhone: {
    title: "Contact Phone",
    use: "The phone number the support team will use for this ticket.",
    source: "backend",
    how: "The number you typed in, or the one on your account if you left it blank.",
  },
  meterId: {
    title: "Meter ID",
    use: "The ID of the meter the complaint is about.",
    source: "input",
    how: "Copied from the machine you picked in Affected Machine/Meter.",
  },
  machineName: {
    title: "Machine Name",
    use: "The machine the complaint is about.",
    source: "input",
    how: "Copied from the machine you picked in Affected Machine/Meter.",
  },
};

export default help;
